import React, {Component} from "react";
import {closeAlert} from "../../../actions/commonsActions";
import {RETAIL, SUPER_ADMIN, USER, USER_ROLES} from "../../../helpers/constants";
import {connect} from "react-redux";
import {
    confirmLoanOrder,
    fetchLoanOrder,
    rejectLoanOrder,
    returnLoanOrderProduct
} from "../../../actions/loan/loanOrderActions";
import {Alert, Button, Card, CardBody, CardTitle} from "reactstrap";
import {I18n} from "../../../I18n/components/loan";
import swal from "sweetalert";
import {Link} from "react-router-dom";
import ReactDOM from "react-dom";
import LoanOrderReturn from "./LoanOrderReturn";
import {goBack} from "connected-react-router";
import {isLoansPermission} from "../../../helpers/companyService";

class LoanOrderInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        this.setState({expanded: urlParams.get('expanded') === "true"});

        const {lang, match, company, authority} = this.props;

        if (!isLoansPermission(company, authority)) {
            swal(I18n[lang].contactUsToAccessThis, '', 'error')
                .then(() => this.props.goBack())
            return;
        }

        const orderId = match && match.params ? match.params.orderId : null;

        this.props.fetchLoanOrder(orderId, lang);
    }

    isRetail = () => {
        const {authority, company} = this.props;
        return authority !== SUPER_ADMIN && company.types.includes(RETAIL);
    }

    isUser = () => {
        const {authority} = this.props;
        return authority === USER;
    }

    showReturningDialog = async () => {
        const {lang, loanOrder} = this.props;
        let wrapper = document.createElement('div');
        const element =
            <LoanOrderReturn
                lang={lang}
                sum={loanOrder.product.sum - loanOrder.returnedSum}
            />;
        ReactDOM.render(element, wrapper)
        let content = wrapper.firstChild;

        await swal({
            title: I18n[lang].returnProduct,
            icon: "warning",
            content: content,
            buttons: {
                cancel: I18n[lang].cancel,
                confirm: {
                    text: I18n[lang].confirm,
                    closeModal: false,
                }
            },
        }).then(async (sum) => {
            if (!sum && sum !== null) {
                await swal(I18n[lang].enterTheSum, "", "error")
                    .then(() => this.showReturningDialog());
            } else if (sum) {
                await this.props.returnProduct(loanOrder.id, lang, {sum: sum, returnMoneyToCard: true});
            }
            swal.stopLoading();
            swal.close();
        }).catch(async error => {
            let message = error && error.message ? error.message : JSON.stringify(error);
            await swal(I18n[lang].error, message, "error");
        });
    }

    getButtonsByOrderStatuses = (orderStatus, orderSubStatus) => {
        const {lang, loading, loanOrder} = this.props;
        if (orderStatus === "SUCCESS" && orderSubStatus !== "RETURNED") {
            return (
                <Button
                    color="danger"
                    type="button"
                    disabled={loading}
                    onClick={() => this.showReturningDialog()}
                >
                    {I18n[lang].return}
                </Button>
            );
        } else if (orderStatus === "IN_PROCESS") {
            return (
                <div>
                    <Button
                        color="danger"
                        type="button"
                        disabled={loading}
                        onClick={() => this.props.rejectLoanOrder(loanOrder.id, lang)}
                    >
                        {I18n[lang].cancel}
                    </Button>
                    {
                        orderSubStatus === "WAITING_FOR_RETAILER_CONFIRM" ?
                            <Button
                                className="ml-2"
                                color="success"
                                type="button"
                                disabled={loading}
                                onClick={() => this.props.confirmLoanOrder(loanOrder.id, lang)}
                            >
                                {I18n[lang].confirm}
                            </Button>
                            : null
                    }
                </div>
            );
        }
    }

    render() {
        const {lang, loading, loanOrder} = this.props;
        const {expanded} = this.state;

        const isRetail = this.isRetail();
        const isUser = this.isUser();
        const returnedSum = loanOrder ? loanOrder.returnedSum : null;
        const orderStatus = loanOrder ? loanOrder.status.status : null;
        const orderSubStatus = loanOrder ? loanOrder.subStatus.subStatus : null;

        const orderInfo = loading
            ? <div className="loading">Loading...</div>
            : !loanOrder
                ? <h5>{I18n[lang].error}</h5>
                : <div>
                    <h5>{I18n[lang].order + " №" + loanOrder.invoiceNumber}</h5>

                    <div className="loan-order-info mt-4">
                        <div>
                            <div>{I18n[lang].phoneNumber + ": "}</div>
                            <div>{loanOrder.clientPhone}</div>
                        </div>
                        <div>
                            <div>{I18n[lang].product + ": "}</div>
                            <div>{loanOrder.product.name}</div>
                        </div>
                        <div>
                            <div>{I18n[lang].price + ": "}</div>
                            <div>{loanOrder.product.sum}</div>
                        </div>
                        <div>
                            <div>{I18n[lang].numberOfProducts + ": "}</div>
                            <div>{loanOrder.product.count}</div>
                        </div>
                        <div>
                            <div>{I18n[lang].numberOfPayments + ": "}</div>
                            <div>{loanOrder.parts}</div>
                        </div>
                        {isRetail ? null :
                            <div>
                                <div>{I18n[lang].company + ": "}</div>
                                <div>{loanOrder.retailerName}</div>
                            </div>
                        }
                        {isRetail && isUser ? null :
                            <div>
                                <div>{I18n[lang].store + ": "}</div>
                                <div>{loanOrder.pointName}</div>
                            </div>
                        }
                        {isRetail && isUser ? null :
                            <div>
                                <div>{I18n[lang].salesman + ": "}</div>
                                <div>{loanOrder.userName + ' / ' + loanOrder.userPhoneNumber}</div>
                            </div>
                        }
                        {!returnedSum ? null :
                            <div>
                                <div>{I18n[lang].refundedAmount + ": "}</div>
                                <div>{returnedSum}</div>
                            </div>
                        }
                        <div>
                            <div>{I18n[lang].created + ": "}</div>
                            <div>{loanOrder.created}</div>
                        </div>
                        <div>
                            <div>{I18n[lang].status + ": "}</div>
                            <div>{loanOrder.status.message}</div>
                        </div>
                        <div>
                            <div>{I18n[lang].extraInfo + ": "}</div>
                            <div>{loanOrder.subStatus.message}</div>
                        </div>
                    </div>
                </div>

        return (<div className={expanded ? "expanded" : null}>
            {/*----------------------- alerts -----------------------------------*/}
            <Alert
                color={`${this.props.alert.alert.status}`}
                isOpen={this.props.alert.isOpen || false}
            >
                {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
            </Alert>
            <Card className={expanded ? "expanded" : null}>
                <CardTitle className="mb-0 p-3 border-bottom bg-light">
                    <div>
                        <i className="mdi mdi-credit-card mr-2"/>
                        {I18n[lang].order}
                    </div>
                </CardTitle>

                <CardBody>
                    {!expanded ? null :
                        <div className="d-flex mb-4">
                            <Link to={`/dashboard/loan/orders?expanded=${expanded}`}>
                                <Button
                                    color="secondary"
                                    type="submit"
                                >
                                    <i className="fa fa-arrow-left mr-2"/>
                                    {I18n[lang].back}
                                </Button>
                            </Link>
                            <Button
                                className="ml-2"
                                color="secondary"
                                type="submit"
                                disabled={loading}
                                onClick={() => this.props.fetchLoanOrder(loanOrder.id, lang)}
                            >
                                {loading ? <i className="fa fa-spinner fa-spin mr-2"/> :
                                    <i className="fa fa-sync mr-2"/>}
                                {I18n[lang].refresh}
                            </Button>
                        </div>
                    }
                    {orderInfo}
                    {!this.isRetail() ? null :
                        <div className="text-center mt-5">
                            {this.getButtonsByOrderStatuses(orderStatus, orderSubStatus)}
                        </div>
                    }
                </CardBody>
            </Card>
        </div>)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchLoanOrder: (orderId, lang) => dispatch(fetchLoanOrder(orderId, lang)),
        rejectLoanOrder: (orderId, lang) => dispatch(rejectLoanOrder(orderId, lang)),
        confirmLoanOrder: (orderId, lang) => dispatch(confirmLoanOrder(orderId, lang)),
        returnProduct: (orderId, lang, returnInfo) => dispatch(returnLoanOrderProduct(orderId, lang, returnInfo)),
        closeAlert: () => dispatch(closeAlert()),
        goBack: () => dispatch(goBack()),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    loanOrder: state.loanOrder.loanOrder,
    loading: state.loanOrder.loading,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(LoanOrderInfo);


// WEBPACK FOOTER //
// ./src/components/Loan/Order/LoanOrderInfo.js